import React from "react";
import { useNavigate } from "react-router-dom";
import { useGetInstructorMySessionsQuery } from "../../services/instructor/instructor";

const statusStyles = {
  Upcoming: "bg-[#FF000017] text-[#FF0000]",
  Completed: "bg-[#DDF8E7] text-[#16A34A]",
};

const SessionsTable = () => {
  const {
    data: sessionsResponse,
    isLoading,
    isError,
  } = useGetInstructorMySessionsQuery({
    page: 1,
    limit: 10,
  });
  const navigate = useNavigate();
  const sessions = sessionsResponse?.data || [];
  if (isLoading) {
    return <p>Loading sessions...</p>;
  }

  if (isError) {
    return <p>Failed to load sessions.</p>;
  }
  return (
    <div className="w-full bg-white px-3 pb-5 pt-3 shadow-[0_-1px_3.8px_0_#00000040] sm:px-4 xl:px-7 xl:pb-7">
      <div className="mb-2 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-5 xl:gap-7">
          <h2 className="text-xl font-semibold leading-8 text-[#1D2026] sm:leading-[48px]">
            Sessions
          </h2>
          <div className="flex flex-wrap gap-3 xl:gap-5">
            <select className="rounded-full border border-[#E9EAF0] px-2.5 py-1 text-sm leading-6 text-[#25252B] focus:outline-none xl:px-3 xl:py-1.5">
              <option>All sessions</option>
            </select>
            <select className="rounded-full border border-[#E9EAF0] px-2.5 py-1 text-sm leading-6 text-[#25252B] focus:outline-none xl:px-3 xl:py-1.5">
              <option>Status</option>
            </select>
          </div>
        </div>

        <button
          type="button"
          onClick={() => navigate("/instructor/manage-sessions")}
          className="w-fit rounded-full border bg-white px-4 py-1 text-sm font-semibold text-[#089BC4] shadow-[1px_1px_4px_0px_#00000040] sm:self-auto xl:mr-6 xl:px-7 xl:text-base"
        >
          View All
        </button>
      </div>
      <div className="-mx-1 overflow-x-auto sm:mx-0">
        <table className="min-w-[720px] w-full text-left font-['Inter']">
          <thead>
            <tr className="text-[#6B7280] text-xs font-medium">
              <th className="py-2 px-2">DATE & TIME</th>
              <th className="py-2 px-2">COURSE</th>
              <th className="py-2 px-2">STUDENT</th>
              <th className="py-2 px-2">SESSION</th>
              {/* <th className="py-2 px-2">STATUS</th> */}
              <th className="py-2 px-2">TYPE</th>
              <th className="py-2 px-2">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {sessions.length === 0 ? (
              <tr>
                <td
                  colSpan={6}
                  className="py-10 text-center text-sm text-[#6E7485]"
                >
                  No sessions found. Your scheduled sessions will appear here.
                </td>
              </tr>
            ) : (
              sessions.map((s) => {
              const sessionType =
                s?.enrollment?.enrollmentType.toLowerCase() === "live classes"
                  ? "live"
                  : "demo";
              return (
                <tr
                  key={s._id}
                  className="border-b border-[#E5E7EB] last:border-0 hover:bg-[#F8F8F8]"
                >
                  <td className="py-3 px-2 whitespace-nowrap text-[#111827] text-sm">
                    <div>{s.sessionDate.split("-").reverse().join("-")}</div>
                    <div>
                      {s.startTime} - {s.endTime}
                    </div>
                  </td>
                  <td className="py-3 px-2 text-sm text-[#1D2026] whitespace-nowrap max-w-[180px] truncate">
                    {s.course.courseTitle}
                  </td>
                  <td className="py-3 px-2 whitespace-nowrap flex items-center gap-2">
                    <img
                      src={s.student.profilePicture.secureUrl}
                      alt={s.student.firstName}
                      className="w-7 h-7 rounded-full object-cover"
                    />
                    <span className="text-sm text-[#111827]">
                      {s.student.firstName} {s.student.lastName}
                    </span>
                  </td>
                  <td className="py-3 px-2 whitespace-nowrap text-sm text-[#111827]">
                    {s.sessionStatus}
                  </td>
                  {/* <td className="py-3 px-2 whitespace-nowrap">
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-medium ${statusStyles[s.status]}`}
                  >
                    {s.status}
                  </span>
                </td> */}
                  <td className="py-3 px-2 whitespace-nowrap text-xs font-medium ">
                    <span
                      className={`rounded-full px-2.5 py-1 ${s.enrollment?.enrollmentType.toLowerCase() === "live classes" ? "bg-[#0E94B91A] text-[#0E94B9]" : "bg-[#0656231A] text-[#065623]"}`}
                    >
                      {" "}
                      {s.enrollment?.enrollmentType?.toLowerCase() ===
                      "live classes"
                        ? "Live Session"
                        : "Demo Session"}
                    </span>
                  </td>
                  <td className="py-3 px-2 whitespace-nowrap">
                    <button
                      onClick={() =>
                        navigate(
                          `/instructor/manage-sessions/${s?._id}?type=${sessionType}`,
                        )
                      }
                      className="text-[#089BC4] text-sm hover:underline"
                    >
                      View
                    </button>
                  </td>
                </tr>
              );
            })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SessionsTable;
